"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subject = exports.Action = exports.Scope = exports.Role = void 0;
var Role;
(function (Role) {
    Role["Admin"] = "Admin";
    Role["ResellerAdmin"] = "ResellerAdmin";
    Role["SchoolAdmin"] = "SchoolAdmin";
    Role["GroupAdmin"] = "GroupAdmin";
    Role["Teacher"] = "Teacher";
    Role["Student"] = "Student";
    Role["Public"] = "Public";
})(Role || (exports.Role = Role = {}));
var Scope;
(function (Scope) {
    Scope["U_Publisher_Author"] = "U_Publisher_Author";
    Scope["U_Populate_School_Clouds"] = "U_Populate_School_Clouds";
    Scope["U_Sales"] = "U_Sales";
    Scope["U_Order_Discount"] = "U_Order_Discount";
})(Scope || (exports.Scope = Scope = {}));
var Action;
(function (Action) {
    Action["Read"] = "Read";
    Action["Write"] = "Write";
})(Action || (exports.Action = Action = {}));
var Subject;
(function (Subject) {
    Subject["Orders"] = "Orders";
    Subject["Bundles"] = "Bundles";
    Subject["QuotableItems"] = "QuotableItems";
    Subject["Institutions"] = "Institutions";
    Subject["Users"] = "Users";
    Subject["Books"] = "Books";
    Subject["Transactions"] = "Transactions";
    Subject["Clouds"] = "Clouds";
    Subject["ResellerUtils"] = "ResellerUtils";
    Subject["Repurchase"] = "Repurchase";
    Subject["DashboardTeacher"] = "DashboardTeacher";
    Subject["Sales"] = "Sales";
    Subject["OrdersDiscount"] = "OrdersDiscount";
    Subject["InstitutionsResellers"] = "InstitutionsResellers";
    Subject["InstitutionsCreate"] = "InstitutionsCreate";
    Subject["Licences"] = "Licences";
    Subject["AppModules"] = "AppModules";
    Subject["Admin"] = "RoleAdmin";
    Subject["Reselleradmin"] = "RoleReselleradmin";
    Subject["Schooladmin"] = "RoleSchooladmin";
    Subject["ResellerAdmin"] = "ResellerAdmin";
    Subject["SchoolAdmin"] = "SchoolAdmin";
    Subject["GroupAdmin"] = "GroupAdmin";
    Subject["Teacher"] = "Teacher";
    Subject["Student"] = "Student";
    Subject["Public"] = "Public";
    Subject["RoleAdmin"] = "RoleAdmin";
})(Subject || (exports.Subject = Subject = {}));
//# sourceMappingURL=types.js.map